import { render, staticRenderFns } from "./CreateVirtualAccountModal.vue?vue&type=template&id=72a854b4&scoped=true"
import script from "./CreateVirtualAccountModal.vue?vue&type=script&lang=js"
export * from "./CreateVirtualAccountModal.vue?vue&type=script&lang=js"
import style0 from "./CreateVirtualAccountModal.vue?vue&type=style&index=0&id=72a854b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a854b4",
  null
  
)

export default component.exports